:host {
  display: block;
  width: 100%;
  @include cms-base-font;
}

.cms-headline {
  color: css-var(theme-text-color);
}

.headline-wrapper {
  max-width: css-var(container-max-width);
  @include cms-margin-center;
}

@include heading-font-size;

.left {
  text-align: left;
}

.center {
  text-align: center;
}
